import type { Subscription } from '@/shared/types/Billing';

import { NEW_SUBSCRIPTION_WINDOW_MS } from './constants';

export type AcquisitionSurveyGate = 'drop' | 'open' | 'wait';

type AcquisitionSurveyGateArgs = {
  hasShown: boolean;
  isFlagError: boolean;
  isFlagLoading: boolean;
  now: number;
  subscription: null | Subscription | undefined;
};

export const isNewSubscription = (subscription: Subscription, now: number) =>
  now - Date.parse(subscription.created) < NEW_SUBSCRIPTION_WINDOW_MS;

export const getAcquisitionSurveyGate = ({
  hasShown,
  isFlagError,
  isFlagLoading,
  now,
  subscription,
}: AcquisitionSurveyGateArgs): AcquisitionSurveyGate => {
  if (!subscription) return 'wait';
  if (!isNewSubscription(subscription, now)) return 'drop';
  if (isFlagLoading) return 'wait';
  if (isFlagError || hasShown) return 'drop';

  return 'open';
};
